<template>
 <bt-chart
    :options="pieOptions"
    style="width:100%;height:100%"
    :autoresize="true"
    :init-options="{renderer:'svg'}"
    ref="chart"
  />  
</template>
<script>
import drawCharts from '@/mixins/drawCharts.js'
import loading from '@/mixins/loading.js'
export default {
  mixins: [drawCharts,loading],
  data(){
    return{
      pieOptions:{}
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'pie'
    },
     title: {
      type: String,
      default: ''
    },
    color:{
      type:Array,
      default:()=>[]
    },
     isLegend:{
      type:Boolean,
      default:false,
    },
  },
  watch:{
     list: {
      handler(val) {
        this.$nextTick(()=>{
          this.showLoading(this.$refs.chart)
          if (val && val.length > 0) {
              this.hideLoading(this.$refs.chart)
               this.pieOptions = {
                tooltip: {
                  trigger: 'item',
                  formatter: '{b}: {c} ({d}%)'
                },
                color: this.color,
                grid:{
                  left:50,
                  right:10,
                  containLable:true
                },       
                title:{
                  text:this.title,
                  textStyle:{
                      fontSize: 14,
                      color: "#ABBEF1"
                  },
                  top:10,
                  left:10
                },
                series:this.getPieSeries(this.list, this.type,this.color)
            }
          }
        })
      },     
      immediate: true
    }
  }
}
</script>

